import "./change-url";
import moment from "moment-timezone";
import { asBool, asDate, asInt, asIntArray, asString } from "./parse";

// Enum for actual URL parameter names
export enum UrlParamName {
    SYSTEM = "system",
    UNIT_ID = "unitId",
    SECTION_IDS = "sectionIds",
    TAG = "tag",
    /** An experience's invitation (VIP) link token: its times show ahead of its release schedule. */
    INVITE = "invite",
    WEB_BOOKING_ID = "webBookingId",
    DATE = "date",
    RULE_ID = "r",
    GUESTS = "guests",
    GUESTS_CHILDREN = "children",
    CHARGE_ID = "ChargeId",
    OFFER_START_TIME = "offerStartTime",
    IS_PAYMENT_LINK = "paymentLink",
    CAPTURED = "Captured",
    IS_NO_SHOW = "isNoShow",
    IS_ACTIVITY_BOOKING = "activityBooking",
    IS_TIMES_CONFIRMED = "timesConfirmed",
    IS_WAIT_LIST = "waitList",
    BOOKING_ID = "bookingId",
    WITH_PAYMENT = "withPayment",
    INQUIRY_PROPOSAL = "inquiryProposal",
    IS_EXPERIENCE_VIEW_MODE = "experienceView",
    EXPERIENCE_ID = "experienceId",
    FONT_BODY = "fontBody",
    FONT_HEADER = "fontHeader",
    FONT_SUBHEADER = "fontSubheader",
    FONT_URL = "fontUrl",
}

export type UrlParams = {
    date: moment.Moment | null;
    guests: number | null;
    guestsChildren: number | null;
    sectionIds: number[];
    system: string;
    tag: string;
    invite: string;
    webBookingId: string;
    unitId: number | null;
    chargeId: string;
    offerStartTime: string;
    isPaymentLink: boolean;
    captured: boolean;
    isNoShow: boolean;
    withPayment: boolean;
    inquiryProposal: boolean;
    isExperienceViewMode: boolean;
};

let lastUrl = "";
let cache: UrlParams;
// eslint-disable-next-line prefer-const
export let getSearchParams = () => {
    if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        cache = {
            system: asString(UrlParamName.SYSTEM, null),
            unitId: asInt(UrlParamName.UNIT_ID),
            sectionIds: asIntArray(UrlParamName.SECTION_IDS),
            tag: asString(UrlParamName.TAG, null),
            invite: asString(UrlParamName.INVITE, null),
            // Query Strings
            webBookingId: asString(UrlParamName.WEB_BOOKING_ID, null),
            // Date moment
            date: asDate(UrlParamName.DATE),
            // Query Number
            guests: asInt(UrlParamName.GUESTS),
            guestsChildren: asInt(UrlParamName.GUESTS_CHILDREN),
            chargeId: asString(UrlParamName.CHARGE_ID, null),
            offerStartTime: asString(UrlParamName.OFFER_START_TIME, null),
            isPaymentLink: asBool(UrlParamName.IS_PAYMENT_LINK),
            captured: asBool(UrlParamName.CAPTURED),
            isNoShow: asBool(UrlParamName.IS_NO_SHOW),
            withPayment: asBool(UrlParamName.WITH_PAYMENT),
            inquiryProposal: asBool(UrlParamName.INQUIRY_PROPOSAL),
            isExperienceViewMode: asBool(UrlParamName.IS_EXPERIENCE_VIEW_MODE),
        };
    }
    return cache;
};
